export default __webpack_public_path__ + "static/media/profile.e89179f6.svg";